import { generatePlugin } from '../component';

//budgetPlugin
export const budgetPlugin = generatePlugin('budget');

//budgetPayAppPlugin
export const budgetPayAppPlugin = generatePlugin('budgetPayApp');

//mainContractPlugin

export const mainContractPlugin = generatePlugin('mainContract');
